module.exports = __webpack_public_path__ + "img/title_sp.95acebab.svg";